import { DiagnocoinLedgerEntryType } from '@/shared/api/protocol-ts/api/billing_new/dto_diagnocoin_new_pb';

import { DiagnocoinHistoryFilter } from './types';

export const DIAGNOCOIN_HISTORY_FILTER_TYPES: Record<
  DiagnocoinHistoryFilter,
  readonly DiagnocoinLedgerEntryType[]
> = {
  [DiagnocoinHistoryFilter.all]: [],
  [DiagnocoinHistoryFilter.purchases]: [
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeCredit,
  ],
  [DiagnocoinHistoryFilter.deductions]: [
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeReserve,
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeExpire,
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeAdjustment,
  ],
  [DiagnocoinHistoryFilter.refunds]: [
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeRelease,
  ],
};

export const DIAGNOCOIN_HISTORY_PAGE_SIZE = 50;
